import type { MessagingGetChatMessages200PageAllOfThreeContentItemAllOfBasicInfo } from './messagingGetChatMessages200PageAllOfThreeContentItemAllOfBasicInfo';
import type { MessagingGetChatMessages200PageAllOfThreeContentItemAllOfSender } from './messagingGetChatMessages200PageAllOfThreeContentItemAllOfSender';
import type { MessagingGetChatMessages200PageAllOfThreeContentItemAllOfStatus } from './messagingGetChatMessages200PageAllOfThreeContentItemAllOfStatus';

export type MessagingGetChatMessages200PageAllOfThreeContentItemAllOf = {
  basicInfo?: MessagingGetChatMessages200PageAllOfThreeContentItemAllOfBasicInfo;
  /** 발신자 정보 */
  sender?: MessagingGetChatMessages200PageAllOfThreeContentItemAllOfSender;
  /** 메시지 상태 정보 */
  status?: MessagingGetChatMessages200PageAllOfThreeContentItemAllOfStatus;
};
